import Typography from '@material-ui/core/Typography'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

import Carousel from '../Carousel'
import HeadBodyCTA from '../UI/HeadBodyCTA'
import Wrapper from '../UI/Wrapper'
import { RelatedSolutionsSection, SlideContent } from './styles'

interface RelatedSolutionsProps {
  relatedSolutions: {
    headline: string
    cta_text: string
    solutions?: any[]
  }
}

const RelatedSolutions = ({ relatedSolutions }: RelatedSolutionsProps) => {
  const slideData = relatedSolutions?.solutions || []
  const slidesToMap = slideData.length > 18 ? slideData.slice(0, 18) : slideData

  return (
    <RelatedSolutionsSection className={relatedSolutions ? 'white' : 'plum'}>
      <Wrapper>
        <Typography className="headline" component="h2" variant="h3">
          {relatedSolutions?.headline}
        </Typography>
        {slidesToMap?.length > 0 && (
          <Carousel
            className={relatedSolutions ? 'white' : 'plum'}
            isSolutionsCarousel={true}
            maxSlidesToShow={2}
            slides={[
              ...slidesToMap.map((solution) => {
                const image = solution?.program?.[0]
                  ? getImage(
                      solution?.program?.[0]?.feature_image_card?.imgixImage,
                    )
                  : solution?.product_category?.[0]
                  ? getImage(
                      solution?.product_category?.[0]?.feature_image_card
                        ?.imgixImage,
                    )
                  : solution?.page_header?.[0]?.topic?.[0]
                  ? getImage(
                      solution?.page_header?.[0]?.topic?.[0]?.feature_image_card
                        ?.imgixImage,
                    )
                  : solution?.page_header?.[0]
                  ? getImage(
                      solution?.page_header?.[0]?.feature_image_card
                        ?.imgixImage,
                    )
                  : solution?.introduction?.[0]?.topic?.[0]
                  ? getImage(
                      solution?.introduction?.[0]?.topic?.[0]
                        ?.feature_image_card?.imgixImage,
                    )
                  : getImage(solution?.product?.[0]?.feature_image?.imgixImage)
                const alt = solution?.program?.[0]
                  ? solution?.program?.[0]?.feature_image_card?.description
                  : solution?.product_category?.[0]
                  ? solution?.product_category?.[0]?.feature_image_card
                      ?.description
                  : solution?.page_header?.[0]?.topic?.[0]
                  ? solution?.page_header?.[0]?.topic?.[0]?.feature_image_card
                      ?.description
                  : solution?.page_header?.[0]
                  ? solution?.page_header?.[0]?.feature_image_card?.description
                  : solution?.introduction?.[0]?.topic?.[0]
                  ? solution?.introduction?.[0]?.topic?.[0]?.feature_image_card
                      ?.description
                  : solution?.product?.[0]?.feature_image?.description
                return (
                  <SlideContent key={solution?.id}>
                    {image ? (
                      <GatsbyImage
                        alt={alt || ''}
                        image={image}
                        objectFit="contain"
                      />
                    ) : null}
                    <div className="contentContainer">
                      <HeadBodyCTA
                        body={
                          solution?.program?.[0]?.short_description ||
                          solution?.product_category?.[0]?.short_description ||
                          solution?.product?.[0]?.short_description ||
                          solution?.page_header?.[0]?.topic?.[0]
                            ?.short_description ||
                          solution?.page_header?.[0]?.topic?.[0]?.job_title ||
                          solution?.page_header?.[0]?.subheading ||
                          solution?.introduction?.[0]?.topic?.[0]
                            ?.short_description
                        }
                        cta={{
                          text: relatedSolutions?.cta_text || '',
                          link: [
                            {
                              url:
                                solution?.pageUrl ||
                                solution?.url ||
                                solution?.productUrl,
                            },
                          ],
                        }}
                        headline={
                          solution?.program?.[0]?.headline ||
                          solution?.product_category?.[0]?.headline ||
                          solution?.product?.[0]?.headline ||
                          solution?.page_header?.[0]?.headline ||
                          solution?.page_header?.[0]?.topic?.[0]?.title ||
                          solution?.introduction?.[0]?.topic?.[0]?.title
                        }
                        headlineColor="primary"
                        lineClamp={true}
                        resizeHeadline={true}
                      />
                    </div>
                  </SlideContent>
                )
              }),
            ]}
          />
        )}
      </Wrapper>
    </RelatedSolutionsSection>
  )
}

export default RelatedSolutions
